import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WaveAuthor from "./WaveAuthor";
import WaveTypeIcon from "./WaveTypeIcon";
import WaveRating from "./WaveRating";
import WaveSlowMode from "./WaveSlowMode";
import WaveDisableLinks from "./WaveDisableLinks";
interface WaveSpecsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean | undefined;
}
export default function WaveSpecs(t0) {
  const $ = _c(21);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "";
  const isChatWave = wave.wave.type === ApiWaveType.Chat;
  const showSlowMode = wave.chat.enabled;
  const t2 = `tw-relative tw-overflow-auto tw-bg-iron-950 ${ringClasses}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-3"><p className="tw-mb-0 tw-text-base tw-font-semibold tw-tracking-tight tw-text-iron-200">General</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-font-medium tw-text-iron-400">Type</span>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== wave.wave.type) {
    t5 = <div className="tw-group tw-flex tw-h-6 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-text-sm">{t4}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveTypeIcon waveType={wave.wave.type} /></div></div>;
    $[2] = wave.wave.type;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isChatWave || $[5] !== wave) {
    t6 = !isChatWave && <div className="tw-group tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-2 tw-text-sm"><span className="tw-font-medium tw-text-iron-400">Voting</span><div className="tw-flex tw-flex-1 tw-justify-end"><WaveRating wave={wave} /></div></div>;
    $[4] = isChatWave;
    $[5] = wave;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="tw-font-medium tw-text-iron-400">Creator</span>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== wave) {
    t8 = <div className="tw-group tw-flex tw-h-6 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-text-sm">{t7}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveAuthor wave={wave} /></div></div>;
    $[8] = wave;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== showSlowMode || $[11] !== wave) {
    t9 = showSlowMode && <><WaveSlowMode wave={wave} /><WaveDisableLinks wave={wave} /></>;
    $[10] = showSlowMode;
    $[11] = wave;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div className="tw-pb-4">{t3}<div className="tw-mt-2.5 tw-flex tw-flex-col tw-gap-2 tw-px-4">{t5}{t6}{t8}{t9}</div></div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t2) {
    t11 = <div className={t2}>{t10}</div>;
    $[18] = t10;
    $[19] = t2;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}